export const commonConstants = {
    BASE_URL : `${global?.window?.location?.protocol}//${global?.window?.location?.hostname}:${global?.window?.location?.port}`,
    ASSETS_GET_SERVICE_URL: 'api/public/assets/get'
};